export const GET_TARGETING_INFO = 'GET_TARGETING_INFO';
export const SAVE_TARGETING_INFO = 'SAVE_TARGETING_INFO';
export const UPDATE_TARGETING_INFO = 'UPDATE_TARGETING_INFO';
export const CHECK_POST_CODE = 'CHECK_POST_CODE';
export const DELETE_ALL_TARGETING_INFO = 'DELETE_ALL_TARGETING_INFO';
